import DurationSummaryItem from './DurationSummaryItem';
export default DurationSummaryItem;
